import { render, staticRenderFns } from "./express.vue?vue&type=template&id=a0445c86&"
import script from "./express.vue?vue&type=script&lang=js&"
export * from "./express.vue?vue&type=script&lang=js&"
import style0 from "./express.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports